import { Component } from "react";
import type { ReactNode } from "react";
import { store } from "./store.ts";

/**
 * Never a blank screen (S17): when a view breaks – say on data an older app kept – a message
 * instead, and „Daten neu laden“, which drops what this device kept of the business and loads it
 * again. Unsaved menus kept on the device go with it; that is said.
 */
export class Crash extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="crash" role="alert" data-testid="crash">
        <h1>Da ist etwas schiefgegangen</h1>
        <p>Die App kam mit den Daten auf diesem Gerät nicht zurecht. Auf dem Server ist nichts verloren.</p>
        <div className="buttons">
          <button
            className="primary"
            onClick={async () => {
              await store.forget();
              location.reload();
            }}
            data-testid="crash-reload"
          >
            Daten neu laden
          </button>
          <button onClick={() => location.assign("#/speisekarten")}>Zu den Speisekarten</button>
        </div>
        <p className="hint">Was hier noch nicht gespeichert war, ist danach weg.</p>
        <details>
          <summary>Fehlermeldung</summary>
          <pre>{error.message}</pre>
        </details>
      </div>
    );
  }
}
